export enum KitElement {
  SHIRT = 'shirt',
  SHORTS = 'shorts',
  SOCKS = 'socks',
  CAP = 'cap',
  HELMET = 'helmet',
}

/** Human-readable labels for kit elements. */
export const KIT_ELEMENT_LABELS: Record<KitElement, string> = {
  [KitElement.SHIRT]: 'Футболка',
  [KitElement.SHORTS]: 'Шорты',
  [KitElement.SOCKS]: 'Гетры',
  [KitElement.CAP]: 'Кепка',
  [KitElement.HELMET]: 'Шлем',
};
